/**
 * ══ CHẶN TRUY CẬP THEO VAI Ở MỨC ĐƯỜNG DẪN — chép `proship-trans/src/lib/routeAccess.ts:19–46` ══
 *
 * LỖ ĐÃ VÁ 16/08/2026 ở bản cũ: `App.tsx` chỉ kiểm ĐÃ ĐĂNG NHẬP; menu bên `Layout.tsx` ẩn trang
 * theo vai, nhưng ẨN MENU KHÔNG PHẢI LÀ CHẶN.
 *
 * NGUYÊN TẮC — ĐÃ MẠNH HƠN TỪ TASK 19: bảng này KHÔNG CÒN phải "giữ khớp" với ma trận menu nữa, vì
 * ma trận menu KHÔNG CÒN bảng vai riêng. `packages/ui/src/nav.ts` chỉ giữ THỨ TỰ · khoá i18n ·
 * `section`, rồi gọi THẲNG `canAccessRoute()` dưới đây (P13, chốt 05/09). Một nguồn sự thật cho cả
 * menu lẫn chốt chặn ⇒ không còn hai bên để lệch. Câu "sửa một bên thì sửa cả hai" của bản trước là
 * luật dựa vào TRÍ NHỚ; nay nó thừa, cố ý.
 * ⚠ Hệ quả: thêm lá menu mới mà QUÊN khai ở `RESTRICTED_ROUTES` thì lá đó rơi vào nhánh "không có
 *   luật ⇒ ai đăng nhập cũng vào được" — `packages/ui/src/nav.test.ts` có ca khoá đúng việc này.
 *
 * Bỏ khỏi bảng gốc: `/reports` `/ceo` `/tap-doan` `/salary-driver` `/salary-perf` `/vetc` — ngoài
 * phạm vi RT (vai `tai_xe` và menu P.Vận tải/Tập đoàn đã cắt, xem CLAUDE.md §5).
 *
 * ⭐ TỆP NÀY PHẢI LÀ DỮ LIỆU THUẦN — KHÔNG import `./authorize.ts`, `./index.ts`, Cedar hay
 * `node:fs`. Đây là cửa `@rs/policy/routes` (package.json `exports["./routes"]`, dựng khung từ Task
 * 17) — Task 19 (sidebar) và mọi mã chạy trong TRÌNH DUYỆT sẽ import từ cửa này. `node:fs` không
 * tồn tại trong trình duyệt (vỡ lúc dựng `apps/web`), và cedar-wasm là mã `.wasm` nặng sẽ phá cổng
 * ngân sách 200 KB gzip. `.dependency-cruiser.cjs` có luật MÁY CHẶN riêng cho đúng bất biến này
 * (`routes-thuan-khong-dung-cedar`) — không chỉ dựa vào chú thích này.
 */
export const OFFICE = ['admin', 'dieu_hanh', 'ke_toan', 'ke_toan_truong', 'giam_doc'] as const
export const AZ_OFFICE = [...OFFICE, 'sale', 'truong_phong_kd'] as const
export const AZ_CEO = ['admin', 'giam_doc', 'ke_toan_truong'] as const
export const OPS_CATALOG = ['admin', 'giam_doc', 'ke_toan_truong', 'truong_phong_kd'] as const
/**
 * ⭐ AI SỬA ĐƯỢC DANH MỤC VẬN HÀNH — gồm BẢNG GIÁ VỐN ĐƯỜNG SẮT (tạo phiên · nạp Excel · ＋ · 🗑). Chép `azCanEditOpsCatalog`
 *   bản cũ (`azSales.ts:140-144`, user SIẾT 19/07): bốn vai `OPS_CATALOG`. Bảng giá nằm ở tab đầu của `/az/ops-catalog`
 *   (`RailOpsPricePane`, `canEdit = azCanEditOpsCatalog(user)` — `Az.tsx:20173`); rs-erp mở thêm `/az/gia-duong-sat` để điều
 *   hành / kế toán XEM + đối soát, nhưng quyền GHI bảng giá vẫn theo luật này (rà 21/10 gia-4).
 * ⚠ KHÔNG xét phạm vi `own` (pham-vi-7, đảo phần "không phạm vi own" của gia-4): bản cũ gọi với `user` của `useAuth` — kiểu `User` (`lib/auth.tsx:40-47`) KHÔNG có `azSalesScope` nên vế `own` luôn qua (pham-vi-7).
 */
export const canEditOpsCatalog = (role: string): boolean =>
  (OPS_CATALOG as readonly string[]).includes(role)
/**
 * ══ Sửa sau review Task 18 vòng 2 (Quan trọng 1) — bản trước NÓI SAI: đưa `truong_phong_kd` thẳng
 * vào đây làm quyền của họ thành VÔ ĐIỀU KIỆN, trong khi bản cũ CÓ ĐIỀU KIỆN ═══════════════════════
 * `/az/purchase-docs`/`/az/vendor-pnl` (hai màn THUẦN GIÁ VỐN) ở bản cũ (`Layout.tsx:153-154`) khai
 * ĐÚNG `roles: OFFICE, extraOk: azCanSeeCost` — `truong_phong_kd` KHÔNG thuộc `OFFICE`, họ vào được
 * QUA `extraOk`, tức qua ĐIỀU KIỆN `azCanSeeCost = azSeeVendorCost===true || azScopeOf!=='own'`,
 * KHÔNG PHẢI một quyền tĩnh theo vai. `COST_DOCS_ROLES` vì vậy CHỈ được là `[...OFFICE]` — thêm
 * `truong_phong_kd` vào đây làm `roles.includes(role)` trả `true` NGAY, escalation (bên dưới) không
 * bao giờ được chạm tới, và điều kiện biến mất hoàn toàn.
 *
 * ⚠ Tính KHẢ ĐẠT của lệch này ĐÃ ĐƯỢC KIỂM CHỨNG THẬT (review, không phải giả thuyết):
 * `proship-trans/src/pages/Catalog.tsx:1378-1384` — ô chọn `azSalesScope` là một `<Select>` KHÔNG
 * LỌC THEO VAI, admin đặt `azSalesScope='own'` cho MỘT `truong_phong_kd` cụ thể được (VD trưởng
 * phòng mới, chưa được tin tưởng đủ). Bản cũ khi đó: `azScopeOf` trả `'own'` ⇒ `azCanSeeCost` chỉ
 * còn đúng nếu CÓ tick riêng ⇒ mặc định `false` ⇒ HAI MÀN GIÁ VỐN BỊ ẨN. Bản lỗi (đưa thẳng vào
 * `COST_DOCS_ROLES`) sẽ VẪN CHO VÀO bất kể `azSalesScope` là gì — lệch theo chiều NỚI QUYỀN, đúng
 * trên hai màn giá vốn, vi phạm CLAUDE.md §7.
 *
 * Với cấu hình MẶC ĐỊNH (chưa ai đổi `azSalesScope` của họ), `truong_phong_kd` VẪN thấy hai màn này
 * — nhưng đi qua ĐÚNG con đường `costViewEscalation` (escalation, không phải `roles`): `azScopeOf`
 * mặc định `'all'` cho mọi vai trừ `sale` nên `canSeeVendorCost()` trả `true` mà không cần tick —
 * y hệt tài liệu `auth.tsx:11`/`auth.tsx:22`, nhưng giờ CÓ THỂ bị siết lại nếu admin đổi
 * `azSalesScope` của một người cụ thể, đúng như bản cũ cho phép.
 */
export const COST_DOCS_ROLES = [...OFFICE] as const

/**
 * ══ Thêm sau review Task 18 (mục 7) ══════════════════════════════════════════════════════════
 * Ai được TICK ô "xem giá thầu phụ" (`az_see_vendor_cost`) CHO NGƯỜI KHÁC — chép `azCanGrantCostView`
 * (`azSales.ts:130-132`, user chốt 05/08): CHỈ `admin` + `giam_doc`. Màn quản lý người dùng thật
 * (Danh mục ▸ Người dùng) thuộc đợt sau (D0x, chưa xác định task cụ thể) — KHÔNG có route/màn hình
 * nào cấp cờ này ở Task 18 (chỉ có SQL thủ công trong test/seed). Luật vẫn nằm SẴN ở đây để đợt sau
 * dùng lại, không phải bịa lúc đó — tránh một bản khác của lỗ "chép thiếu một nửa" đã sửa ở trên.
 */
export const AZ_GRANT_COST_VIEW_ROLES = ['admin', 'giam_doc'] as const

/**
 * ══ AI ĐƯỢC GHI CHI PHÍ ĐƠN HÀNG (F14) ═══════════════════════════════════════════════════════
 * Bảy vai văn phòng TRỪ `sale` — nhập giá mua và chi phí là việc của điều hành và kế toán.
 *
 * ⚠ CỐ Ý KHÁC `AZ_OPERATE_ROLES` (quyền điều hành chặng): `ke_toan` KHÔNG bắn chặng được nhưng
 *   CHÍNH HỌ là người xác nhận khoản chi phí — bậc `draft → acc_confirmed` mang tên "Kế toán xác
 *   nhận". Dùng nhầm danh sách kia là khoá luôn thao tác chính của kế toán (đã tái lập thật:
 *   `e2e/costs.spec.ts` không thấy nút nào khi đăng nhập `ketoan@proship.vn`).
 * ⚠ Danh sách này PHẢI khớp `permit(cost:write)` trong `policies.cedar` — có test canh
 *   (`authorize.test.ts`), vì Cedar không đọc được tệp TS này.
 */
export const COST_WRITE_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh', 'truong_phong_kd',
] as const

/**
 * ══ AI XUẤT HÓA ĐƠN VÀ THU TIỀN (F15) ════════════════════════════════════════════════════════
 * Bốn vai kế toán/BGĐ. `dieu_hanh` ĐỌC được công nợ (`ar:read`) nhưng KHÔNG có tên ở đây —
 * đúng bản cũ. `sale` không có ở cả hai: họ chỉ XIN xuất hóa đơn.
 *
 * ⚠ Ở `@rs/policy` chứ không ở `@rs/ar`, vì `apps/web` cần nó để ẩn nút — mà web KHÔNG được
 *   import gói miền (luật `web → contracts ← api → modules`, `.dependency-cruiser.cjs` chặn).
 *   `@rs/ar` xuất khẩu LẠI hằng này, không khai bản thứ hai.
 * ⚠ Danh sách này PHẢI khớp `permit(ar:write)` trong `policies.cedar` — có test canh.
 */
export const AR_WRITE_ROLES = ['admin', 'giam_doc', 'ke_toan_truong', 'ke_toan'] as const
/**
 * ✏️ Sửa PHIẾU chứng từ BH (ngày · số/ngày HĐ · diễn giải · cờ HĐ đã xuất · TK/mã DV/BKS dòng) — `AR_WRITE_ROLES` CỘNG điều hành,
 * điều hành chỉ khi tờ CHƯA đẩy AMIS (bản cũ `DebtTab` không gác vai, `Az.tsx:28284-28305, :28920-28921`; anh chốt 24/10).
 * Khớp Cedar `arDoc:edit`.
 */
export const AR_DOC_EDIT_ROLES = [...AR_WRITE_ROLES, 'dieu_hanh'] as const

/**
 * ⭐ AI DUYỆT PHIẾU ĐỐI TRỪ CÔNG NỢ (F23) — hẹp hơn `AR_WRITE_ROLES` đúng một bậc: `ke_toan` LẬP
 * được nhưng KHÔNG duyệt được phiếu của chính mình. Bản cũ ghi thẳng ở màn: *"Phiếu chờ Kế toán
 * trưởng duyệt mới giảm công nợ 2 bên"*.
 *
 * ⚠ Ở đây chứ không ở `@rs/ar`, cùng lý do với `AR_WRITE_ROLES`: `apps/web` cần nó để ẩn nút mà
 *   web KHÔNG được import gói miền. `@rs/ar` xuất khẩu LẠI, không khai bản thứ hai.
 */
/* ⚠ KHÔNG có `giam_doc` (ke-toan-6): bản cũ `canApprove = canPay` = admin · KTT (`AR.tsx:3032-3034, :3077-3079`) — GĐ không
 *   duyệt phiếu đối trừ, không thấy nút thu tiền ở `/ar`. Để GĐ duyệt thì phiếu không có CT AMIS (`mayTouchAmis` không có GĐ). */
export const OFFSET_APPROVE_ROLES = ['admin', 'ke_toan_truong'] as const

/**
 * ⭐ AI XIN GIA HẠN NỢ · AI DUYỆT (`0067`). Hai vòng KHÁC nhau, giao nhau ở admin + điều hành (L42, 17/10).
 *
 * ⚠ KHÔNG CÓ `sale` Ở CẢ HAI, dù người biết khách hẹn gì chính là họ. Lý do là một quyết định ĐÃ
 *   CHỐT của người dùng: `/ar → OFFICE`, *"user 18/08: bỏ quyền xem của sale"* (xem bảng
 *   `ROUTE_ROLES` ngay dưới). Màn hạn mức nằm TRONG `/ar`, nên cho `sale` quyền xin ở đây là dựng
 *   một cửa họ không mở nổi — và nếu mở được thì đã lật lại quyết định kia. Kinh doanh nhờ kế toán
 *   bấm hộ, đúng như bản cũ vận hành.
 * ⚠ DUYỆT chép nguyên bản cũ: `dieu_hanh || admin` (`AR.tsx:2358`) — KHÔNG `giam_doc` (L42, chốt 17/10; đợt
 *   trước tự thêm GĐ, nay bỏ theo bản cũ).
 * ⚠ `ke_toan` XIN được nhưng KHÔNG duyệt — người lập không tự duyệt phiếu của mình, cùng khuôn với
 *   `OFFSET_APPROVE_ROLES` ngay trên.
 */
export const CREDIT_EXT_REQUEST_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh',
] as const
export const CREDIT_EXT_APPROVE_ROLES = ['admin', 'dieu_hanh'] as const
/* ⭐ L42 (rà 16/10, chốt 17/10 "theo bản cũ"): nút "＋ Xin gia hạn" của bản cũ KHÔNG xét vai (`AR.tsx:2533`) ⇒ mọi vai
   vào được `/ar` (OFFICE) đều XIN được — thêm `dieu_hanh`. DUYỆT đúng `canApprove = dieu_hanh || admin` (`AR.tsx:2358`)
   — BỎ `giam_doc` mà đợt trước tự thêm. Vì `dieu_hanh` nay vừa xin vừa duyệt: NGƯỜI XIN KHÔNG TỰ DUYỆT phiếu của
   chính mình (`@rs/ar` chốt theo `requested_by_id`) — chốt bảo mật giữ nguyên. */

/**
 * ══ AI TẢI ĐƯỢC DANH SÁCH ĐƠN RA EXCEL ═══════════════════════════════════════════════════════
 * Chép `canExportOrders` (`proship-trans/src/pages/Az.tsx:1418`, user chốt 02/08).
 *
 * ⚠ KHÔNG phải "ai xem được đơn thì tải được". Tệp Excel đơn hàng mang GIÁ VỐN, LÃI, HOA HỒNG và
 *   HẠN MỨC CÔNG NỢ của khách — những thứ mà `sale` và `dieu_hanh` cố ý KHÔNG được thấy trên màn.
 *   Mở nút tải cho họ là cấp lại đúng thứ vừa che đi, chỉ qua một đường khác.
 * ⚠ Ẩn nút chỉ để đỡ chướng mắt. Ngày cửa REST xuất Excel ra đời thì nó phải chặn THẬT ở máy chủ
 *   bằng chính danh sách này (§4). Hiện tệp dựng ở trình duyệt từ dữ liệu màn đã có, nên vòng
 *   chặn thật chính là những cửa đọc đã lọc sẵn theo vai.
 */
export const ORDER_EXPORT_ROLES = ['admin', 'ke_toan', 'ke_toan_truong', 'giam_doc'] as const

/**
 * ══ AI ĐỤNG ĐƯỢC HOA HỒNG SALE (F27) ═════════════════════════════════════════════════════════
 * BA vòng lồng nhau, hẹp dần — và cố ý KHÔNG dùng lại `AZ_OFFICE`/`OFFICE`:
 *
 *   ĐỌC   — thêm `truong_phong_kd`: họ phải xem được bảng của phòng mình.
 *   GHI   — lập chính sách, lập đợt, tính lại, ghi điểm văn hoá. Vẫn có `truong_phong_kd`.
 *   DUYỆT — duyệt và PHÁT tiền. CHỈ BGĐ + kế toán trưởng.
 *
 * ⚠ `sale` KHÔNG có tên ở BẤT KỲ vòng nào, kể cả vòng ĐỌC. Một người xem được bảng hoa hồng là xem
 *   được lãi gộp của mọi đơn trong kỳ — tức toàn bộ giá vốn của công ty, suy ngược ra từ doanh thu
 *   và tỷ lệ lãi. Muốn sale xem được phần của riêng họ thì phải dựng một cửa lọc theo chính họ,
 *   không phải nới danh sách này.
 * ⚠ NGƯỜI LẬP KHÔNG TỰ DUYỆT: `truong_phong_kd` lập được đợt cho phòng mình nhưng không duyệt
 *   được khoản chi của phòng mình. Đây là lý do vòng DUYỆT tồn tại tách khỏi vòng GHI.
 */
export const COMMISSION_READ_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'truong_phong_kd',
] as const
export const COMMISSION_WRITE_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'truong_phong_kd',
] as const
export const COMMISSION_APPROVE_ROLES = ['admin', 'giam_doc', 'ke_toan_truong'] as const
/**
 * 💰 Ai vào được màn "Hoa hồng của tôi" (`0126`) — CÓ `sale`, khác hẳn `COMMISSION_READ_ROLES`.
 *
 * ⚠ Rộng hơn KHÔNG có nghĩa là lỏng hơn: cửa sau nó chỉ trả tiền của CHÍNH người gọi và lọc theo
 *   `actor.id` ở máy chủ. Đây đúng là "cửa lọc theo chính họ" mà khối chú thích trên đã hẹn.
 */
export const COMMISSION_MINE_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'truong_phong_kd', 'sale',
] as const

/**
 * ⭐ TỜ TRÌNH CHÍNH SÁCH HOA HỒNG KHÁCH (tab 🧾 Duyệt chi ngoài của `/az/pricing`, `0097`).
 *
 *   GHI   — mọi vai vào được màn Giá công bố, CÓ `sale`: sale lập tờ trình ngay tại form đơn khi gõ tay hoa
 *           hồng mà chưa có chính sách (user chốt 02/08). Tờ trình không chứa giá vốn.
 *   CẤP 1 — Trưởng phòng KD. CẤP 2 — Ban giám đốc / Kế toán trưởng. `admin` duyệt được cả hai, lần lượt.
 *
 * ⚠ Cedar mở `custPolicy:approve` cho HỢP hai cấp; cấp nào được bấm do `@rs/commission` chốt theo trạng
 *   thái tờ — cùng khuôn `COMMISSION_APPROVE_ROLES`.
 */
export const CUST_POLICY_WRITE_ROLES = [
  'admin', 'dieu_hanh', 'ke_toan', 'ke_toan_truong', 'giam_doc', 'sale', 'truong_phong_kd',
] as const
export const CUST_POLICY_MANAGER_ROLES = ['admin', 'truong_phong_kd'] as const
export const CUST_POLICY_DIRECTOR_ROLES = ['admin', 'giam_doc', 'ke_toan_truong'] as const

/**
 * ══ AI VÀO ĐƯỢC MÀN CHÀO GIÁ THẦU PHỤ (F28) ══════════════════════════════════════════════════
 * Chép `OPERATE_ROLES` của `@rs/ops` — chọn nhà thầu SINH THẲNG một chặng, nên danh sách phải
 * TRÙNG với danh sách bắn chặng. Lệch một vai là có người mở được phiên rồi không chốt được.
 *
 * ⚠ Ở đây chứ không import từ `@rs/ops`: `apps/web` cần nó để ẩn menu, mà web KHÔNG được import
 *   gói miền (`.dependency-cruiser.cjs` chặn). Có test canh hai danh sách khớp nhau.
 * ⚠ Danh sách này PHẢI khớp `permit(chaogia:write)` trong `policies.cedar` — có test canh.
 */
export const AZ_OPERATE_ROUTE_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'dieu_hanh', 'truong_phong_kd',
] as const

/**
 * ══ AI ĐIỀU HÀNH ĐƯỢC MẢNG VỎ CONTAINER (F29) ════════════════════════════════════════════════
 * Chép `AZ_OFFICE` của bảng đường dẫn — `/az/container-ops` từ ĐỢT 0 đã mở cho cả bảy vai văn
 * phòng, kể cả `sale`, và F29 KHÔNG siết lại: mảng vỏ không có ô giá vốn nào, nên không có lý do
 * gì để hẹp hơn màn đơn hàng.
 *
 * ⚠ Ở `@rs/policy` chứ không ở `@rs/container`: `apps/web` cần nó để ẩn nút, mà web KHÔNG được
 *   import gói miền (`.dependency-cruiser.cjs` chặn).
 * ⚠ Danh sách này PHẢI khớp `permit(vocont:write)` trong `policies.cedar` — có test canh.
 */
export const CONT_OPS_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh', 'truong_phong_kd', 'sale',
] as const

/**
 * ══ AI KHOÁ KỲ MẢNG VỎ (F30) ═════════════════════════════════════════════════════════════════
 * HẸP HƠN `CONT_OPS_ROLES` hẳn bốn vai. Người ghi phiếu KHÔNG tự khoá kỳ của chính mình — đó là
 * cả điểm của việc khoá: nó chốt lại con số để người khác ký lên.
 *
 * ⚠ Cùng khuôn với `OFFSET_APPROVE_ROLES` (F23) và `COMMISSION_APPROVE_ROLES` (F27): Cedar chỉ mở
 *   cửa theo một hành động, còn bậc hẹp hơn thì miền chốt lần hai.
 */
export const CONT_LOCK_ROLES = ['admin', 'giam_doc', 'ke_toan_truong'] as const

/**
 * ══ AI XEM VÀ AI ĐẶT MỤC TIÊU (F31) ══════════════════════════════════════════════════════════
 * ĐỌC — bảy vai văn phòng TRỪ `sale`: bảng đạt mục tiêu bày doanh thu và lãi gộp của TỪNG người
 * bán cạnh nhau, và đó là thứ chỉ cấp quản lý cần thấy.
 * ĐẶT — hẹp hơn nữa: BGĐ và trưởng phòng kinh doanh. Người bị giao chỉ tiêu không tự đặt chỉ tiêu
 * cho mình.
 *
 * ⚠ `ncc` không có tên ở cả hai: thầu phụ vào bằng `ncc:portal`, và chỉ thấy kế hoạch của CHÍNH họ.
 */
export const PLAN_READ_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh', 'truong_phong_kd',
] as const
export const PLAN_WRITE_ROLES = ['admin', 'giam_doc', 'truong_phong_kd'] as const

/**
 * SỬA CHỈ TIÊU KH-BC TH — HẸP HƠN `PLAN_WRITE_ROLES`, và hẹp có lý do.
 *
 * Bản cũ gác lưới này bằng `role === 'admin' || role === 'ke_toan_truong'`
 * (`AzDashboard.tsx:880`) và nói thẳng ra ở màn: *"Chỉ Kế toán trưởng/Admin mới mở khóa sửa
 * được số kế hoạch"*. `truong_phong_kd` ĐẶT được mục tiêu theo KỲ (F31) nhưng KHÔNG đặt chỉ
 * tiêu doanh thu cả năm — hai quyết định khác cấp. Mượn chung một danh sách là nới quyền mà
 * không ai quyết.
 */
export const KHTH_WRITE_ROLES = ['admin', 'ke_toan_truong'] as const

/**
 * Ô 📦 SẢN LƯỢNG NĂM TRƯỚC của KH-BC TH — mọi vai vào được Dashboard RT (`AZ_CEO`) ghi, KHÔNG theo khoá 🔒 lưới: bản cũ
 * `upsertPrevQty` không gác vai lẫn `planLocked` (`AzDashboard.tsx:892-896,2112`; V03440/V03441). Chỉ là số tham khảo
 * "cùng kỳ", không đụng chỉ tiêu.
 */
export const KHTH_PREV_QTY_ROLES = AZ_CEO

/**
 * BÁO CÁO TÀI CHÍNH nhập từ Excel (tab 📑 BCTC) — ĐỌC RỘNG, GHI HẸP.
 *
 * Cả ban giám đốc lẫn điều hành cần NHÌN bức tranh tài chính; nhưng nhập nó vào thì chỉ kế toán
 * trưởng và admin — đây là số ĐÃ CHỐT trên sổ thật, và người nhập chịu trách nhiệm về việc nó
 * khớp. `sale` không có tên ở cả hai: báo cáo tài chính không phải việc của người bán hàng.
 */
export const BCTC_READ_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh', 'truong_phong_kd',
] as const
export const BCTC_WRITE_ROLES = ['admin', 'ke_toan_truong'] as const
/** ✏️ Đổi LINK FILE MẪU BCTC — mọi vai đọc được BCTC (bản cũ không xét vai, `AzDashboard.tsx:1222-1227`; V03555). */
export const BCTC_TEMPLATE_WRITE_ROLES = [...BCTC_READ_ROLES] as const

/**
 * 📥 NHẬP KỲ BCTC CÒN TRỐNG — rộng hơn `BCTC_WRITE_ROLES` đúng một vai: GIÁM ĐỐC (dashboard-5, soát 21/10). Bản cũ cho mọi vai
 * vào Dashboard RT (`admin · giam_doc · ke_toan_truong`, `lib/routeAccess.ts:44`) bấm 📥 Nhập kỳ (`AzDashboard.tsx:4403`); chỉ
 * GHI ĐÈ kỳ đã có số mới là KTT / admin (`:1272-1278`, `:4581-4599`, user 21/08). Xoá kỳ và kế hoạch năm vẫn `BCTC_WRITE_ROLES`.
 */
export const BCTC_IMPORT_ROLES = ['admin', 'ke_toan_truong', 'giam_doc'] as const

/**
 * ══ AI ĐƯỢC RÀ SOÁT SỔ TIỀN, AI KÍCH HOẠT TỰ VÁ ══════════════════════════════════════════════
 *
 * ⭐ TỰ VÁ KHI MỞ MÀN như bản cũ (`Finance.tsx:3725-3760` — `useEffect` vá mỗi khi mở `/finance`; thieu-10, chốt mục 4.1 rà
 *   21/10, thay §C17 "nút cho KTT"): ai mở được bộ soi thì lần mở đó tự áp kế hoạch vá. Kế hoạch tính LẠI ở máy chủ từ chính
 *   sổ (không nhận gì từ màn), chỉ ba loại vá máy chắc chắn đúng, cửa an toàn 24 giờ giữ nguyên, và mỗi miếng vá đi qua cửa
 *   của miền sở hữu (có vết ở nhật ký kiểm tra) — khác bản cũ chỉ `console.info`.
 *
 * ⚠ `sale` không có tên ở cả hai: sổ tiền không phải việc của người bán hàng, và danh sách lỗi kế
 *   toán lọt ra ngoài phòng kế toán chỉ sinh đồn đoán.
 */
export const LEDGER_AUDIT_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh',
] as const
export const LEDGER_HEAL_ROLES = LEDGER_AUDIT_ROLES

/**
 * ⭐ AI XEM ĐƯỢC ĐƠN HỆ RATRACO CŨ trên màn Đơn hàng (0151) — đúng bảy vai văn phòng của Cedar `legacy:read`, KHÔNG có
 * `ncc`. `authorize.test.ts` ghim hai nguồn bằng nhau với cả tám vai; danh sách là DANH SÁCH CHO PHÉP ⇒ vai mới
 * thứ chín mặc định KHÔNG thấy.
 * Cửa `POST /az/orders/bang*` đọc danh sách này (đỡ thêm một lượt Cedar mỗi request).
 * ⚠ V8 của Node 22 sập tiến trình khi khử tối ưu `authorize()` ("unreachable code", `MaterializeHeapObjects`) — tái lập
 *   cả trên HEAD sạch, chỉ với `GET /az/orders` (một lượt Cedar mỗi request ở `authorizePlugin`); Node 24 không bị.
 *   Bỏ lượt Cedar ở đây CHỈ giảm tần suất, không chữa — chữa bằng lên Node 24.
 */
export const LEGACY_READ_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh', 'truong_phong_kd', 'sale',
] as const

/**
 * Ai GHI ĐƠN — khớp `permit(order:write)` (`authorize.test.ts` ghim). `apps/web` dùng để bày lựa chọn "Huỷ" cho đơn còn
 * "Chờ xác nhận": bản cũ `azCanCancelOrder` (`azSales.ts:185`) không đòi `canOperate`, người dùng chốt 17/10.
 */
export const ORDER_WRITE_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh', 'truong_phong_kd', 'sale',
] as const

/**
 * Ai XIN xuất hóa đơn — bảy vai văn phòng, CÓ `sale`: chính họ biết khách cần hóa đơn lúc nào.
 * Khớp `permit(bill:request)` trong `policies.cedar`; `apps/web` dùng để bày nút.
 */
export const BILL_REQUEST_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh', 'truong_phong_kd', 'sale',
] as const

/**
 * ══ AI LÀM VIỆC VỚI BẢNG KÊ MUA (F17) ════════════════════════════════════════════════════════
 * `AP_STATEMENT_ROLES` — LẬP bảng kê (thầu phụ · chi phí đơn hàng · chi hộ) và TRÌNH CHI: bản cũ `IS_STMT` (`Az.tsx:169`,
 *   dùng ở `:18106` chi hộ · `:23495` chi phí đơn hàng · `:26992` Chứng từ MH) — điều hành, kế toán, BGĐ, TPKD VÀ `sale`
 *   (user 02/08). Sale chỉ làm được khi được tick "xem giá thầu phụ" (cùng luật mục menu `/az/purchase-docs`) — chốt ở
 *   `@rs/ap.mayMakeStatement`. Khớp `permit(apStatement:write)` (tích hợp Lô 2–3, 17/10).
 * `AP_POST_ROLES` — XÁC NHẬN và GHI SỔ: chỉ kế toán trở lên.
 * ⚠ Ở `@rs/policy` vì `apps/web` cần chúng để ẩn nút (web không import được gói miền).
 */
export const AP_STATEMENT_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'dieu_hanh', 'truong_phong_kd', 'sale',
] as const
/**
 * ⚠ KHÔNG có `giam_doc` (T28, rà Lô 3 · nhóm 2): bản cũ xác nhận / ghi sổ bảng kê NCC · chi phí đơn hàng · chi hộ đều gác
 * `isAcc` = `IS_ACC` (`Az.tsx:161` admin · kế toán · KTT; dùng ở `:27727-27728`, `:28084`). GĐ chỉ XEM (cùng tinh thần
 * `BANK_WRITE_ROLES`/`AMIS_WRITE_ROLES`/`AR_ISSUE_ROLES`).
 */
export const AP_POST_ROLES = ['admin', 'ke_toan_truong', 'ke_toan'] as const
/**
 * 🔁 Đổi ĐỐI TƯỢNG PHẢI TRẢ (33885) của bảng kê chi hộ còn nháp — bản cũ `st === 'draft' && isOps`, `IS_OPS` = admin · điều hành ·
 * KTT (`Az.tsx:162, :18388-18397`, hd-ban-19). Kế toán viên · GĐ · TPKD · sale chỉ xem.
 */
export const ONBEHALF_VENDOR_ROLES = ['admin', 'dieu_hanh', 'ke_toan_truong'] as const
/**
 * 🚚 `IS_OPS` của bản cũ (`Az.tsx:162`) = admin · điều hành · KTT — tab Bảng kê NCC gác bằng nó: nút "Xác nhận bảng kê" hàng loạt
 * (`:27993`), dải "Sau khi khớp giá" của đối soát đường sắt (`canStmt={isOps}`, `:27880`). `isAcc || isOps` (+ kế toán viên) cho
 * "Lập ĐNTT" / "Đẩy AMIS" hàng loạt (`:27995-27996`) và điều kiện đẩy AMIS bảng kê (`eligAmis`, `:27380`).
 */
export const AP_OPS_ROLES = ['admin', 'dieu_hanh', 'ke_toan_truong'] as const
/** `isAcc || isOps` của tab Bảng kê NCC (bản cũ `Az.tsx:27380, :27995-27996`) — đẩy AMIS bảng kê: kế toán CỘNG điều hành. */
export const AP_STMT_AMIS_ROLES = ['admin', 'dieu_hanh', 'ke_toan_truong', 'ke_toan'] as const
/**
 * 🧾 Ai THẤY tab Hóa đơn MH ở `/az/purchase-docs` — bản cũ `IS_APDOC` (`Az.tsx:26103`, `canApDoc` `:26990`, user chốt 10/08) =
 * kế toán · KTT · GĐ · admin. RỘNG hơn `AP_POST_ROLES` đúng một vai. GĐ SỬA phiếu ở tab này như kế toán (ngày · diễn giải · dòng —
 * bản cũ không gác vai khi lưu, anh chốt 24/10 theo bản cũ, thay đề xuất "GĐ chỉ xem" ke-toan-12); đẩy / nạp / gỡ AMIS vẫn
 * `AMIS_WRITE_ROLES` (T28, 17/10).
 */
export const AP_DOC_READ_ROLES = ['admin', 'ke_toan_truong', 'ke_toan', 'giam_doc'] as const

/* ══ LÔ 3 (rà 16/10, người dùng chốt 17/10 — "theo bản cũ, giữ chốt bảo mật") ═════════════════════════════════════
   Mỗi hằng dưới đây PHẢI khớp một `permit` trong `policies.cedar` hoặc một chốt ở miền — `authorize.test.ts` ghim. */

/**
 * 💵 GHI SỔ TIỀN (Báo Có/Nợ · phiếu thu/chi · đối trừ · ghép phiếu đôi) — T28. Bản cũ `Finance.tsx:3675`
 * `viewOnly = role === 'giam_doc'` ⇒ GĐ CHỈ XEM; mọi vai văn phòng khác (kể cả ĐIỀU HÀNH) ghi được. Khớp `finance:write`.
 */
export const BANK_WRITE_ROLES = ['admin', 'ke_toan_truong', 'ke_toan', 'dieu_hanh'] as const
/**
 * 📤 DỰNG / ĐẨY CHỨNG TỪ AMIS — T28. Bản cũ `Finance.tsx:3669` `canPushAmis` = kế toán viên · KTT · admin (user
 * 06/08); GĐ không. Khớp `amis:write`.
 */
export const AMIS_WRITE_ROLES = ['admin', 'ke_toan_truong', 'ke_toan'] as const
/**
 * 🧾 XUẤT HÓA ĐƠN BÁN (từ bảng kê) — T28. Bản cũ `IS_ACC` (`Az.tsx:161`) = admin · kế toán · KTT; GĐ không có. HẸP hơn
 * `AR_WRITE_ROLES` (GĐ VẪN thu tiền được — `Az.tsx:28226`, L9). Cedar mở `ar:write`, `@rs/ar` chốt bậc này lần hai.
 */
export const AR_ISSUE_ROLES = ['admin', 'ke_toan_truong', 'ke_toan'] as const
/**
 * 📋 ĐỌC CHỨNG TỪ BÁN HÀNG ở `/az/billing` — C8. Bản cũ khai mục menu `AZ_OFFICE` (`Layout.tsx:143`) và màn chạy cho
 * sale/TPKD (không xét vai). Phạm vi `own` ⇒ CHỈ khách mình phụ trách (`inSaleScope`, `@rs/ar`). Khớp `billing:read`.
 * ⚠ KHÁC `ar:read` (sổ công nợ `/ar` — user 18/08 "bỏ quyền xem của sale"): đây chỉ là bảng kê · chứng từ BH · thu hộ.
 */
export const BILLING_READ_ROLES = [...AZ_OFFICE] as const
/**
 * 🧾 DUYỆT CHI (`/approvals`) — anh chốt 24/10/2026, KHÁC bản cũ (`routeAccess.ts:33` chỉ `OFFICE`): MỌI người dùng nội bộ
 * lập · sửa · trình ĐNTT và theo dõi phiếu của chính mình. Khớp `dntt:read`/`dntt:write` (`policies.cedar`).
 * `/chi` (chứng từ chi tiền) KHÔNG đổi — vẫn `OFFICE`.
 */
export const PAY_REQUEST_ROLES = [...AZ_OFFICE] as const
/**
 * 🔒 Vai CHỈ thấy / đụng phiếu ĐNTT CỦA MÌNH ở Duyệt chi (mình lập · được gán duyệt · đang chờ mình bấm bước), BẤT KỂ ô
 * "Phạm vi xem Duyệt chi" — `@rs/pay.ownScopeOf` ép. Kế toán · KTT · GĐ · admin xem hết; điều hành theo ô phạm vi như bản cũ.
 */
export const PAY_REQUEST_OWN_ONLY_ROLES = ['truong_phong_kd', 'sale'] as const
/**
 * ✉ XẾP THƯ ĐỐI CHIẾU / BẢNG KÊ CÔNG NỢ vào hộp thư đi (khách lẫn NCC) — anh chốt 23/10 theo bản cũ (D02247 · D02286):
 * `outbox.add` của `AzDebtDocModal` / `AzVendorDebtDocModal` không xét vai (`AzDebtDoc.tsx:88 · 268`), hộp mở từ Danh mục
 * (menu ⋯ khách / NCC — bảy vai văn phòng) và từ Thống kê ▸ công nợ khách (sale / TPKD, `Az.tsx:14802`). Khớp `debtLetter:write`.
 * ⚠ Chỉ là SỔ GHI thư đã soạn — rs-erp không tự gửi thư (`sentAt` để trống), không đổi số liệu công nợ nào.
 */
export const DEBT_LETTER_ROLES = [...AZ_OFFICE] as const
/**
 * ✉ SỬA NƠI NHẬN BÁO CÁO DÒNG TIỀN CEO — T24. Bản cũ: ✎ ở `/finance` cho mọi vai không `viewOnly`
 * (`Finance.tsx:4257-4262`) + ✎ ở Dashboard RT cho `AZ_CEO` (`AzDashboard.tsx:1890`) ⇒ hợp lại = cả văn phòng.
 */
export const CEO_MAIL_WRITE_ROLES = [...OFFICE] as const
/** 🏷 SỬA TÊN KHỐI ở `/settings` — cả văn phòng như bản cũ (`Settings.tsx:41-56` không xét vai; pham-vi-9). */
export const DIVISION_WRITE_ROLES = [...OFFICE] as const
/**
 * 📋 LƯU ĐẦU TỜ BẢNG GIÁ ĐƯỜNG SẮT + 🔗 Link Drive (`0205`, kiểm kê H02553/H02558) — ai vào được màn Giá công bố là sửa
 * được, như bản cũ (`RailPriceModal.persist`, `Az.tsx:14326` không xét vai). Chỉ đụng cột `rail_doc_*` của tờ giá.
 */
export const RAIL_DOC_WRITE_ROLES = [...AZ_OFFICE] as const
/**
 * 🏦 SỬA TÀI KHOẢN NHẬN TIỀN + TÊN GIÁM ĐỐC KÝ (in trên ĐNTT · bảng kê bán) — T24. Bản cũ để nút ở popup bảng kê
 * KHÔNG xét vai (`Az.tsx:19715`); giữ CHỐT BẢO MẬT (đổi STK nhận tiền là kiểu gian lận kinh điển, cùng lý do
 * `canEditBank` `Catalog.tsx:4534`) ⇒ chỉ kế toán + BGĐ. ❓ Hỏi người dùng nếu muốn mở như bản cũ.
 */
export const PAY_ACCOUNT_WRITE_ROLES = ['admin', 'giam_doc', 'ke_toan_truong', 'ke_toan'] as const
/**
 * 📚 DANH MỤC KẾ TOÁN — T30. Cửa `accCatalog:write` giữ năm vai; HAI danh mục hẹp hơn theo bản cũ:
 * 🏦 TK ngân hàng (số dư đầu kỳ) `Catalog.tsx:6087` và 📅 TK mặc định theo năm `Catalog.tsx:5956` — `canEdit` = admin ·
 * KTT. `@rs/accounting` chốt lần hai theo LOẠI danh mục.
 */
export const ACC_CATALOG_WRITE_ROLES = ['admin', 'giam_doc', 'ke_toan', 'ke_toan_truong', 'dieu_hanh'] as const
/** ĐỌC danh mục kế toán (tab "📊 Kế toán / AMIS") — mọi vai vào được `/catalog` như bản cũ (`Catalog.tsx:165-186`; dashboard-9). */
export const ACC_CATALOG_READ_ROLES = [...ACC_CATALOG_WRITE_ROLES, 'sale', 'truong_phong_kd'] as const
export const ACC_CATALOG_CHIEF_ROLES = ['admin', 'ke_toan_truong'] as const
export const ACC_CATALOG_CHIEF_KINDS = ['bank-accounts', 'tk-year-defaults'] as const
/**
 * 📥 NHẬP TK NGÂN HÀNG HÀNG LOẠT — bản cũ `ACC_BULK_ROLES` (`Catalog.tsx:5491`, dùng ở `:6088` `canBulk`): admin · kế toán ·
 * KTT. Hộp dán bản cũ THÊM MỚI và GHI ĐÈ dòng trùng số TK (`Catalog.tsx:6106`, kể cả số dư đầu kỳ) ⇒ kế toán viên ghi được
 * TK ngân hàng qua hộp dán. Màn vẫn chỉ hiện ✏️ / ＋ đơn lẻ cho `ACC_CATALOG_CHIEF_ROLES` (`canEdit` `:6087`); máy chủ
 * nhận cả ba vai vì hộp dán ghi từng dòng qua CÙNG cửa tạo / sửa (tích hợp Lô 2–3, 17/10).
 */
export const ACC_BANK_BULK_ROLES = ['admin', 'ke_toan', 'ke_toan_truong'] as const
/**
 * 📥 NÚT DÁN HÀNG LOẠT Hệ tài khoản KT — bản cũ `ACC_BULK_ROLES` (`Catalog.tsx:5491`, `canBulk` `:5679`): admin · kế toán · KTT.
 * Chỉ là cổng NÚT (D03299 · D03309, chốt 23/10 theo bản cũ): năm vai `accCatalog:write` vẫn thêm / sửa được từng TK.
 */
export const ACC_BULK_ROLES = ACC_BANK_BULK_ROLES
/** Vai này sửa được danh mục kế toán loại `kind` không — CÙNG một luật cho màn (ẩn nút) và miền (403). */
export const mayWriteAccCatalog = (role: string, kind: string): boolean =>
  (kind === 'bank-accounts' ? ACC_BANK_BULK_ROLES
    : (ACC_CATALOG_CHIEF_KINDS as readonly string[]).includes(kind) ? ACC_CATALOG_CHIEF_ROLES : ACC_CATALOG_WRITE_ROLES)
    .some((r) => r === role)

export const RT_ROLES: string[] = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'truong_phong_kd', 'dieu_hanh', 'sale', 'ncc',
]

/**
 * ══ AI TÁC ĐỘNG ĐƯỢC TÀI KHOẢN NHÂN SỰ NÀO — MA TRẬN C4 (soi 16/10) ═════════════════════════════
 * Trước đây `user:write` của TPKD/KTT gần như bằng admin: tự PATCH vai mình thành `admin` → 204, tạo
 * người vai `admin` → 201, đặt `azSalesScope='all'` cho sale → 204. Bản cũ (`Catalog.tsx:1246`) cũng
 * hở y vậy nhưng chỉ là kho trình duyệt; ở đây là máy chủ thật, nên §4 thắng §7.
 *
 *   · `USER_ADMIN_ROLES` — gán MỌI vai, sửa MỌI ô (kể cả mở phạm vi, cấp giá vốn, khoá người khác).
 *   · `USER_SALE_MANAGER_ROLES` — ô hồ sơ THƯỜNG (CCCD · STK · SĐT · loại HĐ…) của MỌI người (bản cũ
 *     `Catalog.tsx:1163`, chốt 17/10); ô QUYỀN thì CHỈ hồ sơ đang và sẽ là vai `sale`, và chỉ chiều KHÔNG
 *     mở rộng quyền (siết về `'own'` thì được, nới ra `'all'` hay mở khoá thì không).
 *   · Không ai tự đổi vai / khoá / phạm vi / quyền giá vốn của CHÍNH MÌNH.
 * Chốt thật ở `@rs/identity` (`userWriteError`); `apps/web` đọc các hằng này chỉ để không bày ô
 * mà máy chủ sẽ từ chối.
 */
export const STAFF_ROLES = [
  'admin', 'giam_doc', 'ke_toan_truong', 'ke_toan', 'truong_phong_kd', 'dieu_hanh', 'sale',
] as const
export const USER_ADMIN_ROLES = ['admin', 'giam_doc'] as const
export const USER_SALE_MANAGER_ROLES = ['ke_toan_truong', 'truong_phong_kd'] as const
/** Khớp `permit(user:write)` trong `policies.cedar` — cửa vào; ma trận bên trong mới là chốt. */
export const USER_WRITE_ROLES = [...USER_ADMIN_ROLES, ...USER_SALE_MANAGER_ROLES] as const
/**
 * CẤP LẠI MẬT KHẨU / GỠ–NỐI NCC cho tài khoản CỔNG THẦU PHỤ — khớp `permit(vendorUser:write)`.
 * Tách khỏi `user:write` (C4): cấp lại mật khẩu là cầm được tài khoản của một công ty ngoài, nối sang
 * NCC khác là cho thầu phụ này đọc việc của thầu phụ kia. Bản cũ KHÔNG có hai thao tác này (kho trình
 * duyệt không có mật khẩu; tài khoản gắn NCC lúc tick rồi thôi) ⇒ giữ chặt: chỉ admin + giám đốc.
 */
export const VENDOR_USER_WRITE_ROLES = ['admin', 'giam_doc'] as const
/**
 * ĐĂNG NHẬP BẰNG MẬT KHẨU cho nhân sự nội bộ (E13 sửa 19/10/2026) — bên cạnh FADO SSO.
 *   · `USER_PASSWORD_SELF_ROLES` — tự đặt / đổi mật khẩu CỦA CHÍNH MÌNH, khớp `permit(user:changeOwnPassword)`.
 *     Bản cũ `PasswordCard.tsx` ①: MỌI người dùng.
 *   · `USER_PASSWORD_RESET_ROLES` — cấp lại MẬT KHẨU TẠM cho người khác, khớp `permit(user:resetPassword)`. Bản cũ
 *     `PasswordCard.tsx:48` `canReset = admin || ke_toan_truong`. Chốt bảo mật thêm (bản cũ là kho trình duyệt nên
 *     hở vô hại): KTT KHÔNG cấp được cho vai admin / giám đốc — cầm mật khẩu tạm là đăng nhập được thay người đó
 *     (`@rs/identity` ▸ `passwordResetError`).
 */
export const USER_PASSWORD_SELF_ROLES = [...STAFF_ROLES] as const
export const USER_PASSWORD_RESET_ROLES = ['admin', 'ke_toan_truong'] as const
/**
 * CẤP tài khoản cổng (tick "Cấp cổng" ở hồ sơ NCC) và KHOÁ / MỞ KHOÁ nó — khớp `permit(vendorUser:provision)`.
 * Theo bản cũ `Catalog.tsx:4555-4566` (`syncPortalUser`: tick ⇒ sinh/kích hoạt tài khoản, bỏ tick ⇒ khoá),
 * chạy cho MỌI vai sửa được NCC — tức `AZ_OFFICE`, đúng tập `partner:write` (`policies.cedar`). Người dùng
 * chốt 17/10. Vết kiểm toán vẫn ghi ở `@rs/identity` (`vendorUsers.ts`).
 */
export const VENDOR_USER_PROVISION_ROLES = [...AZ_OFFICE] as const
/**
 * Sửa CẤP DUYỆT (`PATCH /catalog/approval-rules/:id`) — khớp `permit(approvalRule:write)`. Tách khỏi
 * `user:write` (C4 vòng 2): `extraUserIds` nhận uuid bất kỳ và luật duyệt cho qua khi người làm nằm
 * trong đó ở MỌI bước kể cả "đã chi", nên ai sửa được cấp duyệt là tự duyệt được tiền của mình.
 */
export const APPROVAL_RULE_WRITE_ROLES = ['admin', 'giam_doc'] as const

export const RT_ROUTES: string[] = [
  '/login', '/tra-cuu', '/ncc',
  '/az/dashboard', '/az/sales', '/az/pricing', '/az/stats', '/az/billing', '/az/ops',
  '/az/purchase-docs', '/az/vendor-pnl', '/az/gia-duong-sat', '/az/ops-catalog',
  '/az/container-ops',
  '/az/hoa-hong', '/hoa-hong-cua-toi', '/az/chao-gia', '/az/ke-hoach',
  '/approvals', '/chi', '/catalog', '/quan-tri', '/finance', '/ar', '/ap', '/chung-tu', '/settings',
  '/',
  '/ncc/login',   // E15 — cổng đăng nhập thầu phụ, công khai như /login
]

/**
 * Đường dẫn HẠN CHẾ → vai được vào. KHÔNG có ở đây = ai đăng nhập cũng vào được.
 *
 * ⚠ Khác bản cũ `routeAccess.ts` ở chỗ có THÊM các đường dẫn `/az/*` — bản cũ chỉ chặn
 * `/az/dashboard` ở lớp này (các trang AZ khác chỉ ẩn menu ở `Layout.tsx`, đúng lỗ hổng mà tệp này
 * sinh ra để vá). Vai gán cho từng đường dẫn CHÉP NGUYÊN từ cột `roles` của `Layout.tsx`
 * (`NAV_AZ`, dòng ~139–165) — đó mới là nguồn sự thật CHO VAI của các trang AZ, vì bản
 * `routeAccess.ts` gốc chưa từng có các trang này (LOGISTICS RT là phần thêm sau trong bản cũ).
 *
 * ⭐ QUYẾT ĐỊNH E19 (chốt 04/09): `/az/pricing` giữ `OFFICE` (không phải `OFFICE` trừ `dieu_hanh`)
 * — `dieu_hanh` NẰM TRONG `OFFICE` nên VẪN THẤY `/az/pricing`, đúng `Layout.tsx:144`
 * (`roles: OFFICE`, không có `extraOk`). Xem báo cáo Task 18 để biết kế hoạch từng ghi ngược lại.
 */
export interface RestrictedRoute {
  path: string
  roles: readonly string[]
  /**
   * Route CÒN mở được bằng escalation THEO TỪNG NGƯỜI (không theo vai) — chép `extraOk:
   * azCanSeeCost` ở `Layout.tsx` bản cũ (user chốt 05/08). CHỈ đặt trên hai màn THUẦN GIÁ VỐN.
   * `canAccessRoute()` chỉ xét cờ này SAU KHI đã thua ở `roles.includes(role)` — không thay thế,
   * chỉ CỘNG THÊM quyền.
   *
   * ⚠ TASK 19 ĐÃ CÀI (`packages/ui/src/nav.ts` · `apps/web/src/router.tsx` — cả hai truyền đủ cờ,
   * có ca test đỏ khi bỏ cờ). Giữ nguyên cảnh báo dưới đây cho mọi lời gọi MỚI: nếu chỉ
   * gọi `canAccessRoute(role, path)` (2 tham số, không truyền cờ của người đang đăng nhập), một
   * `sale` được tick riêng `az_see_vendor_cost` sẽ bị ẨN OAN hai mục menu này trong khi MÁY CHỦ
   * (đã truyền cờ — xem `plugins/authorize.ts`) vẫn cho vào — menu và chặn LỆCH NHAU, đúng lỗ hổng
   * gốc mà cả `routeAccess.ts` lẫn Task 18 tồn tại để vá, chỉ đổi chiều (giờ menu ẨN NHẦM trang
   * ĐƯỢC PHÉP, không phải CHO VÀO trang bị chặn — nhẹ hơn nhưng vẫn là một lỗi UX/niềm tin). Phải
   * truyền `{ azSeeVendorCost, azSalesScope }` của actor đang đăng nhập vào tham số thứ ba.
   */
  costViewEscalation?: true
  /**
   * ⭐ Vai THẤY MỤC MENU — HẸP HƠN (hoặc bằng) `roles`. Vắng mặt ⇒ menu = đường dẫn (mặc định).
   *
   * Bản cũ có đúng một ca đường dẫn mở RỘNG hơn menu: `/az/pricing` KHÔNG nằm trong `routeAccess.ts:29-46` (ai
   * đăng nhập cũng vào) nhưng mục menu chỉ `roles: OFFICE` (`Layout.tsx:144`). TPKD tới đó qua chuông duyệt CSHH
   * cấp 1, nút "Xem Giá công bố ›" và câu chặn ĐNTT hoa hồng (`Az.tsx:23447` `?tab=commission`); sale tới đó qua
   * tờ giá đường sắt. Người dùng chốt 17/10: làm theo bản cũ.
   * ⚠ Chỉ HẸP menu, không bao giờ nới: menu hiện ⇒ đường dẫn mở (`canShowInMenu` gọi `canAccessRoute` trước),
   *   nên "menu mở mà bị đá" vẫn không thể xảy ra.
   */
  menuRoles?: readonly string[]
}

export const RESTRICTED_ROUTES: RestrictedRoute[] = [
  { path: '/finance', roles: OFFICE },
  { path: '/ap', roles: OFFICE },
  { path: '/chung-tu', roles: OFFICE },
  // 24/10/2026 — mở cho MỌI người dùng nội bộ (anh chốt, khác bản cũ); TPKD · sale chỉ thấy phiếu của mình (`PAY_REQUEST_OWN_ONLY_ROLES`).
  { path: '/approvals', roles: PAY_REQUEST_ROLES },
  // F19 tách khỏi `/approvals` thành mục menu riêng (anh chốt 19/09/2026) — CÙNG vai với nó.
  { path: '/chi', roles: OFFICE },
  { path: '/quan-tri', roles: OFFICE },
  { path: '/settings', roles: OFFICE },
  { path: '/ar', roles: OFFICE },            // user 18/08: bỏ quyền xem của sale
  { path: '/catalog', roles: AZ_OFFICE },
  { path: '/az/dashboard', roles: AZ_CEO },
  // E19: dieu_hanh ∈ OFFICE ⇒ CÓ thấy. C5/L11 (rà 16/10, chốt 17/10): bản cũ KHÔNG chặn đường dẫn này
  // (`routeAccess.ts:29-46`) ⇒ TPKD duyệt CSHH cấp 1 / xem phiên mình trình, sale mở tờ giá đường sắt; MENU vẫn
  // chỉ `OFFICE` (`Layout.tsx:144`). Tab 📊 Phân tích tự gác bằng quyền xem giá vốn (`pricing.tsx`).
  { path: '/az/pricing', roles: AZ_OFFICE, menuRoles: OFFICE },
  // Mục 8 (review Task 18, sửa lại ở vòng 2 — Quan trọng 1): `roles: COST_DOCS_ROLES` (= OFFICE)
  // + `costViewEscalation` ≡ ĐÚNG `roles: OFFICE, extraOk: azCanSeeCost` của Layout.tsx bản cũ.
  // `truong_phong_kd`/`sale` KHÔNG nằm trong `roles` — cả hai đi qua escalation THEO TỪNG NGƯỜI
  // (`canSeeVendorCost()` bên dưới), khác nhau ở giá trị MẶC ĐỊNH của `azScopeOf` theo vai.
  { path: '/az/purchase-docs', roles: COST_DOCS_ROLES, costViewEscalation: true },
  { path: '/az/vendor-pnl', roles: COST_DOCS_ROLES, costViewEscalation: true },
  // F25 — MÀN THUẦN GIÁ VỐN thứ ba: bảng giá đường sắt là giá MUA, bảng kê đối soát là số nhà vận
  // chuyển đòi. Cùng hình dạng quyền với hai màn trên, kể cả escalation theo TỪNG NGƯỜI.
  { path: '/az/gia-duong-sat', roles: COST_DOCS_ROLES, costViewEscalation: true },
  // F27 — bảng hoa hồng mang lãi gộp TỪNG ĐƠN và tiền TỪNG NGƯỜI. `sale` KHÔNG vào được, kể cả
  // được tick xem giá vốn: `costViewEscalation` cố ý KHÔNG có ở đây (xem `COMMISSION_READ_ROLES`).
  { path: '/az/hoa-hong', roles: COMMISSION_READ_ROLES },
  // 💰 `0126` — HOA HỒNG CỦA TÔI. Mở cho CẢ `sale`, và đó là cả lý do màn này tách khỏi màn trên:
  // cửa của nó (`hoahongCuaToi:read`) KHÔNG trả hai sheet, không trả số toàn công ty, và
  // `@rs/commission.myCommission` lọc theo `actor.id` — mở rộng vai ở đây không mở rộng dữ liệu.
  { path: '/hoa-hong-cua-toi', roles: COMMISSION_MINE_ROLES },
  // F28 — chào giá thầu phụ. CÙNG nhóm vai với điều hành chặng, vì chọn nhà thầu sinh thẳng một
  // chặng: ai mở được phiên thì cũng phải bắn được chặng, nếu không luồng đứt ở bước cuối.
  { path: '/az/chao-gia', roles: AZ_OPERATE_ROUTE_ROLES },
  // F31 — bảng đạt mục tiêu bày doanh thu và lãi gộp của TỪNG người bán cạnh nhau, nên `sale`
  // KHÔNG vào được. `costViewEscalation` cố ý không có: tick "xem giá thầu phụ" nói về giá vốn
  // của đơn, không nói về thu nhập và thứ hạng của đồng nghiệp.
  { path: '/az/ke-hoach', roles: PLAN_READ_ROLES },
  { path: '/az/ops-catalog', roles: OPS_CATALOG },
  { path: '/az/sales', roles: AZ_OFFICE },
  { path: '/az/billing', roles: AZ_OFFICE },
  { path: '/az/stats', roles: AZ_OFFICE },
  { path: '/az/ops', roles: AZ_OFFICE },
  { path: '/az/container-ops', roles: AZ_OFFICE },
]

/**
 * Đường dẫn CÔNG KHAI — mọi vai (kể cả `ncc`) đều vào được, khớp tiền tố (`/ncc/login` nằm trong
 * nhánh `/ncc` nên tự động công khai theo — đúng E15, KHÔNG cần liệt kê riêng).
 */
export const PUBLIC_ROUTES = ['/login', '/tra-cuu', '/ncc']

/**
 * ══ TRANG GỐC ĐƯA NGƯỜI DÙNG ĐI ĐÂU ══════════════════════════════════════════════════════════
 * Chép `homePath` của bản cũ (`proship-trans/src/lib/appMode.ts:32`):
 *   `export const homePath = APP_MODE === 'rt' ? '/az/sales' : '/'`
 * Bản RT **không có** Dashboard P.Vận tải nên vào thẳng màn Đơn hàng. rs-erp CHỈ có bản RT.
 *
 * ⛔ TRƯỚC ĐÂY rs-erp vẽ `HomePage` — trang bàn giao D01 in phiên bản, trạng thái CSDL và số
 *   migration. Chính tệp đó ghi *"Sẽ bị thay ở D03"* và không ai thay. Hệ quả: **mọi lượt đăng
 *   nhập và mọi lượt bị đá về đều đáp xuống một trang chẩn đoán kỹ thuật** — thứ đầu tiên người
 *   dùng thật nhìn thấy mỗi sáng. Ảnh chụp đối chiếu ngày 11/09 lôi ra đúng chuyện đó.
 *
 * ⚠ `/az/sales` mở cho `AZ_OFFICE`, tức MỌI vai văn phòng. Vai `ncc` đã được chốt riêng đứng
 *   TRƯỚC (`router.tsx`), nên không vai hợp lệ nào rơi vào cảnh "bị lái tới chỗ mình không vào
 *   được". Vai LẠ thì vẫn phải kiểm — xem chốt chống vòng lặp ở `router.tsx`.
 */
export const HOME_PATH = '/az/sales'

/** Hai cột dữ liệu TỪNG NGƯỜI quyết định `azCanSeeCost` bản cũ — KHÔNG phải theo vai. */
export interface CostViewFlags {
  azSeeVendorCost?: boolean
  azSalesScope?: 'own' | 'all'
}

/**
 * ══ Chép ĐÚNG `azCanSeeCost`/`azScopeOf` (azSales.ts:112-129 bản cũ) ═════════════════════════════
 * `azScopeOf(user) = user.azSalesScope ?? (role==='sale' ? 'own' : 'all')` — `tai_xe` ngoài phạm
 * vi RT nên bỏ khỏi nhánh mặc định `'own'`. `azCanSeeCost(user) = user.azSeeVendorCost===true ||
 * azScopeOf(user)!=='own'`.
 *
 * FAIL-CLOSED: gọi `canAccessRoute()` KHÔNG truyền `u` (hai tham số, mọi lời gọi cũ trước Task 18
 * mục 8) ⇒ `u = {}` ⇒ coi như KHÔNG có cờ nào. Với `role !== 'sale'`, `azScopeOf({}) = 'all'` vẫn
 * `!== 'own'` nên hàm NÀY trả `true` — nhưng đó KHÔNG PHẢI fail-open: giá trị đó chỉ có ý nghĩa khi
 * `costViewEscalation` (`/az/purchase-docs`/`/az/vendor-pnl`, xem `COST_DOCS_ROLES`) CỘNG THÊM vào
 * một vai CHƯA có quyền qua `roles.includes()` — ĐÚNG SAU khi sửa Quan trọng 1 (review vòng 2),
 * CẢ `sale` LẪN `truong_phong_kd` đều đi qua nhánh escalation này cho hai route đó (khác nhau ở giá
 * trị MẶC ĐỊNH của `azScopeOf`: `'own'` cho `sale`, `'all'` cho `truong_phong_kd`) — không còn là
 * "chỉ `sale` mới phụ thuộc cờ này" như chú thích cũ (SAI) từng ghi.
 *
 * ⚠ ══ CỐ Ý LỆCH VỚI E16 — KHÔNG PHẢI ĐIỂM CẦN QUYẾT ĐỊNH THÊM (review vòng 2, Quan trọng 2) ══════
 * Bản cũ dùng CHUNG một hàm `azCanSeeCost` cho CẢ việc mở TRANG (menu/route) LẪN việc CÓ SỐ giá vốn
 * trong dữ liệu. E16 (anh chốt 03/09, D03 §4.3.1) CỐ Ý TÁCH ĐÔI hai việc đó — vì bản cũ rò giá vốn
 * cho gần như mọi vai qua đúng cơ chế `azScopeOf` này (`azScopeOf(user) !== 'own'` mặc định TRUE
 * cho hầu hết vai): con số giá vốn trong DỮ LIỆU (trường `vendorCost`/`grossMargin`/`vendorPrice`,
 * xem `order-out.ts`) giờ CHỈ cấp khi `azSeeVendorCost === true` ĐƯỢC TICK TƯỜNG MINH — không còn
 * đường `azScopeOf !== 'own'` nào cho phần dữ liệu (xem `policies.cedar`, hành động
 * `order:readCost` — permit/forbid chỉ xét `principal.azSeeVendorCost`, không xét scope).
 *
 * Vậy: hàm `canSeeVendorCost()` Ở ĐÂY (tầng ĐƯỜNG DẪN, mở/đóng một TRANG) bám ĐÚNG bản cũ (cả hai
 * nhánh `tick` VÀ `scope`); tầng DỮ LIỆU (Cedar `order:readCost`, cắt SỐ trong response) bám ĐÚNG
 * E16 (chỉ nhánh `tick`). HAI TẦNG CỐ Ý KHÔNG GIỐNG NHAU — một `sale` được gán `azSalesScope='all'`
 * (không tick) VÀO ĐƯỢC trang `/az/vendor-pnl` nhưng KHÔNG THẤY một con số giá vốn nào trong dữ
 * liệu của trang đó (khi D04+ dựng module thật, route đó phải tự gọi `authorize('order:readCost')`
 * y hệt `/az/sales` — xem `rt-stubs.ts`). Đây là ĐÁNH ĐỔI ĐÃ NHẬN của E16, không phải một trạng
 * thái thứ ba còn chờ quyết định — KHÔNG mở mục quyết định mới cho việc này.
 */
/**
 * ══ MỘT ĐỊNH NGHĨA DUY NHẤT của `azScopeOf` — chép `proship-trans/src/lib/azSales.ts:112` ═══════
 *     azScopeOf = (u) => u?.azSalesScope ?? (u?.role === 'sale' || u?.role === 'tai_xe' ? 'own' : 'all')
 * (`tai_xe` ngoài phạm vi RT — CLAUDE.md §5 — nên bỏ khỏi nhánh mặc định `'own'`.)
 *
 * ⭐ TÁCH RA THÀNH HÀM XUẤT KHẨU (không phải một phép tính nằm chìm trong `canSeeVendorCost`) vì
 * `session.ts` (`@rs/identity`) CẦN ĐÚNG luật này khi cột `app_user.az_sales_scope` vắng giá trị.
 * Trước đó `session.ts` tự viết `?? 'all'` — MỘT LUẬT PHÂN QUYỀN CỦA BẢN CŨ BỊ CHÉP THÀNH NƠI THỨ
 * HAI RỒI HAI NƠI LỆCH NHAU, đúng loại lỗi đã ngốn 3 vòng review ở Task 18. Ai đổi luật thì đổi ở
 * ĐÂY, một chỗ; không có bản sao nào để quên.
 *
 * ⚠ `ap_scope` CỐ Ý **KHÁC** và **KHÔNG dùng hàm này** — không phải bỏ sót, đừng "sửa cho nhất
 *   quán". Mặc định bản cũ của `ap_scope` (`proship-trans/src/types.ts:191`) là "tài xế: own, còn
 *   lại: all"; `tai_xe` đã cắt khỏi RT ⇒ `?? 'all'` trong `session.ts` ĐÚNG cho cả 8 vai RT. Gán
 *   `azScopeOf` cho nó sẽ SIẾT NHẦM `sale` ở phân hệ AP — lệch bản cũ, vi phạm CLAUDE.md §7.
 *
 * FAIL-CLOSED (CLAUDE.md §4): giá trị VẮNG MẶT — `undefined` từ tham số, hay NULL đọc lên từ
 * `app_user.az_sales_scope` — KHÔNG BAO GIỜ được quy về `'all'` cho `sale`. Xem
 * `apps/api/drizzle/0013_az_sales_scope_not_null.sql`: lỗ này đã được tái lập THẬT (một `sale`
 * có cột NULL gọi `/az/purchase-docs` và `/az/vendor-pnl` → 200 · 200, bản cũ 403 · 403). Lớp
 * CSDL (`SET NOT NULL`) chặn NULL sinh ra; hàm này chặn hậu quả nếu NULL vẫn lọt tới đây.
 * Giá trị TƯỜNG MINH luôn thắng mặc định theo vai — admin siết một `truong_phong_kd` xuống
 * `'own'` vẫn có tác dụng (xem `COST_DOCS_ROLES`).
 */
export const azScopeOf = (
  role: string | undefined,
  azSalesScope?: 'own' | 'all' | null | undefined,
): 'own' | 'all' => azSalesScope ?? (role === 'sale' ? 'own' : 'all')

/**
 * `azCanSeeCost` bản cũ (`azSales.ts:124`) — ai được xem GIÁ VỐN / LÃI GỘP.
 * XUẤT KHẨU (trước đây riêng tư trong tệp này) để `@rs/quote` cắt `cost_price_at`/`est_buy_price`
 * khỏi response bằng ĐÚNG luật này. Bản cũ chỉ ẩn ở giao diện; ở rs-erp cắt ở máy chủ (§4), và
 * chép luật thành nơi thứ hai là đúng loại lỗi đã ngốn 3 vòng review ở Task 18.
 */
export const canSeeVendorCost = (role: string, u: CostViewFlags): boolean => {
  const scope = azScopeOf(role, u.azSalesScope)
  return u.azSeeVendorCost === true || scope !== 'own'
}

/* `canAccessRoute` · `canShowInMenu` đã CHUYỂN sang `./grants.ts` (D03c Đợt 1) — giờ tính theo QUYỀN (mặc định = luật vai
   của `RESTRICTED_ROUTES` ở trên, cộng phần anh chỉnh trên màn cấu hình). Không đặt lại ở đây: `grants.ts` đọc tệp này, đọc
   ngược thì thành vòng (`khong-phu-thuoc-vong`). */

/**
 * ══ BẢNG 184 Ô — VIẾT TAY, ĐỘC LẬP VỚI `canAccessRoute()` ═══════════════════════════════════════
 * ⚠ Sửa sau review Task 18 (mục 1 — NGHIÊM TRỌNG) — bản đầu SINH bảng này TỪ CHÍNH `canAccessRoute`
 * (`Object.fromEntries(RT_ROLES.map(role => ... canAccessRoute(role, route) ...))`), khiến
 * `matrix.test.ts` so một hàm với CHÍNH NÓ — 184 khẳng định `x === x`, KHÔNG BAO GIỜ đỏ được. Đã
 * tái lập thật: đổi `roles: OFFICE` → `AZ_OFFICE` ở `/az/pricing` phía trên thì `pnpm test` (500
 * ca, gồm cả ma trận quyền) VẪN XANH HẾT — không một khẳng định nào trong toàn kho nói rõ
 * `sale` không vào được `/az/purchase-docs`/`/az/vendor-pnl`/`/az/pricing`, hay `dieu_hanh` không
 * vào được `/az/ops-catalog` (đúng bốn mục nghiệm thu D03 §7, mục 14/15/16/19).
 *
 * Bảng dưới đây là 184 GIÁ TRỊ GÕ TAY, không gọi lại `canAccessRoute`/`RESTRICTED_ROUTES` nào cả —
 * nếu ai đó lỡ đổi vai của một đường dẫn trong `RESTRICTED_ROUTES` phía trên, `matrix.test.ts`
 * (khẳng định `canAccessRoute(role, route) === EXPECTED_ACCESS[role][route]`) sẽ đỏ NGAY, vì hai
 * bên giờ là HAI NGUỒN ĐỘC LẬP thật sự — nguồn sự thật cho giá trị ở đây là cột `roles` của
 * `Layout.tsx` (đối chiếu trực tiếp, không suy từ mã đang chạy).
 */
export const EXPECTED_ACCESS: Record<string, Record<string, boolean>> = {
  // Admin/giám đốc/KTT thấy TẤT CẢ — thành viên của OFFICE, AZ_OFFICE, AZ_CEO, OPS_CATALOG.
  admin: {
    '/login': true, '/tra-cuu': true, '/ncc': true,
    '/az/dashboard': true, '/az/sales': true, '/az/pricing': true, '/az/stats': true,
    '/az/billing': true, '/az/ops': true, '/az/purchase-docs': true, '/az/vendor-pnl': true,
    '/az/gia-duong-sat': true,
    '/az/hoa-hong': true,
    '/hoa-hong-cua-toi': true,
    '/az/chao-gia': true,
    '/az/ke-hoach': true,
    '/az/ops-catalog': true, '/az/container-ops': true,
    '/approvals': true, '/chi': true, '/catalog': true, '/quan-tri': true, '/finance': true, '/ar': true,
    '/ap': true, '/chung-tu': true, '/settings': true, '/': true, '/ncc/login': true,
  },
  giam_doc: {
    '/login': true, '/tra-cuu': true, '/ncc': true,
    '/az/dashboard': true, '/az/sales': true, '/az/pricing': true, '/az/stats': true,
    '/az/billing': true, '/az/ops': true, '/az/purchase-docs': true, '/az/vendor-pnl': true,
    '/az/gia-duong-sat': true,
    '/az/hoa-hong': true,
    '/hoa-hong-cua-toi': true,
    '/az/chao-gia': true,
    '/az/ke-hoach': true,
    '/az/ops-catalog': true, '/az/container-ops': true,
    '/approvals': true, '/chi': true, '/catalog': true, '/quan-tri': true, '/finance': true, '/ar': true,
    '/ap': true, '/chung-tu': true, '/settings': true, '/': true, '/ncc/login': true,
  },
  ke_toan_truong: {
    '/login': true, '/tra-cuu': true, '/ncc': true,
    '/az/dashboard': true, '/az/sales': true, '/az/pricing': true, '/az/stats': true,
    '/az/billing': true, '/az/ops': true, '/az/purchase-docs': true, '/az/vendor-pnl': true,
    '/az/gia-duong-sat': true,
    '/az/hoa-hong': true,
    '/hoa-hong-cua-toi': true,
    '/az/chao-gia': true,
    '/az/ke-hoach': true,
    '/az/ops-catalog': true, '/az/container-ops': true,
    '/approvals': true, '/chi': true, '/catalog': true, '/quan-tri': true, '/finance': true, '/ar': true,
    '/ap': true, '/chung-tu': true, '/settings': true, '/': true, '/ncc/login': true,
  },
  // ke_toan: OFFICE + AZ_OFFICE, KHÔNG AZ_CEO, KHÔNG OPS_CATALOG ⇒ chặn đúng 2: dashboard, ops-catalog.
  ke_toan: {
    '/login': true, '/tra-cuu': true, '/ncc': true,
    '/az/dashboard': false, '/az/sales': true, '/az/pricing': true, '/az/stats': true,
    '/az/billing': true, '/az/ops': true, '/az/purchase-docs': true, '/az/vendor-pnl': true,
    '/az/gia-duong-sat': true,
    '/az/hoa-hong': true,
    '/hoa-hong-cua-toi': true,
    '/az/chao-gia': false,
    '/az/ke-hoach': true,
    '/az/ops-catalog': false, '/az/container-ops': true,
    '/approvals': true, '/chi': true, '/catalog': true, '/quan-tri': true, '/finance': true, '/ar': true,
    '/ap': true, '/chung-tu': true, '/settings': true, '/': true, '/ncc/login': true,
  },
  // truong_phong_kd: AZ_OFFICE + OPS_CATALOG + COST_DOCS_ROLES, KHÔNG OFFICE, KHÔNG AZ_CEO — mục
  // nghiệm thu 19 (D03 §7: "dieuhanh gõ /az/ops-catalog → bị đá" áp cho dieu_hanh, KHÔNG áp cho
  // truong_phong_kd — truong_phong_kd chính là vai ĐƯỢC PHÉP vào /az/ops-catalog).
  // ⭐ Mục 8 (review Task 18): purchase-docs/vendor-pnl = TRUE ở CA MẶC ĐỊNH (2 tham số, không cờ
  // — đúng ô 184-ô này) — bám bản cũ (auth.tsx:11: "trưởng phòng KD thấy đơn CẢ PHÒNG + giá vốn").
  // ⚠ Sửa sau review vòng 2 (Quan trọng 1): giá trị TRUE này đến từ ĐI QUA `costViewEscalation`
  // (azScopeOf mặc định 'all' cho vai này khi KHÔNG có cờ) — KHÔNG PHẢI từ `roles`/`COST_DOCS_ROLES`
  // (đã bỏ `truong_phong_kd` khỏi đó). Nếu admin gán `azSalesScope='own'` cho MỘT người cụ thể (khả
  // thi — `Catalog.tsx:1378-1384` không lọc theo vai), ô NÀY (2 tham số, mặc định) không đổi, nhưng
  // `canAccessRoute('truong_phong_kd', route, { azSalesScope: 'own' })` sẽ trả `false` — xem ca kiểm
  // tương ứng ở `matrix.test.ts`. Đây là hai ô TỪNG `false` ở bản đầu Task 18, một quy-về-sai kiểu E19.
  truong_phong_kd: {
    '/login': true, '/tra-cuu': true, '/ncc': true,
    // C5 (chốt 17/10): bản cũ không chặn `/az/pricing` — TPKD duyệt CSHH cấp 1 tại tab 🧾. Menu vẫn ẩn (`menuRoles`).
    '/az/dashboard': false, '/az/sales': true, '/az/pricing': true, '/az/stats': true,
    '/az/billing': true, '/az/ops': true, '/az/purchase-docs': true, '/az/vendor-pnl': true,
    '/az/gia-duong-sat': true,
    '/az/hoa-hong': true,
    '/hoa-hong-cua-toi': true,
    '/az/chao-gia': true,
    '/az/ke-hoach': true,
    '/az/ops-catalog': true, '/az/container-ops': true,
    '/approvals': true, '/chi': false, '/catalog': true, '/quan-tri': false, '/finance': false, '/ar': false,
    '/ap': false, '/chung-tu': false, '/settings': false, '/': true, '/ncc/login': true,
  },
  // dieu_hanh: OFFICE + AZ_OFFICE, KHÔNG AZ_CEO, KHÔNG OPS_CATALOG — CÙNG HÌNH DẠNG với ke_toan.
  // ⭐ E19 (chốt 04/09): '/az/pricing' = true (dieu_hanh ∈ OFFICE) — mục nghiệm thu D03 §7 mục 10.
  // Mục 19 (D03 §7): dieu_hanh gõ /az/ops-catalog → bị đá = false ở đây.
  dieu_hanh: {
    '/login': true, '/tra-cuu': true, '/ncc': true,
    '/az/dashboard': false, '/az/sales': true, '/az/pricing': true, '/az/stats': true,
    '/az/billing': true, '/az/ops': true, '/az/purchase-docs': true, '/az/vendor-pnl': true,
    '/az/gia-duong-sat': true,
    '/az/hoa-hong': false,
    '/hoa-hong-cua-toi': false,
    '/az/chao-gia': true,
    '/az/ke-hoach': true,
    '/az/ops-catalog': false, '/az/container-ops': true,
    '/approvals': true, '/chi': true, '/catalog': true, '/quan-tri': true, '/finance': true, '/ar': true,
    '/ap': true, '/chung-tu': true, '/settings': true, '/': true, '/ncc/login': true,
  },
  // sale: CHỈ AZ_OFFICE. Mục nghiệm thu D03 §7: 14 (purchase-docs), 15 (vendor-pnl) false; 16 (pricing) ĐÃ
  // đảo thành true ngày 17/10 (bản cũ không chặn đường dẫn, chỉ ẩn menu). Cũng khớp bản cũ "sale chỉ vào danh mục, KHÔNG vào AR/sổ phụ/công nợ".
  sale: {
    '/login': true, '/tra-cuu': true, '/ncc': true,
    // L11 (chốt 17/10): mục 16 cũ (pricing = false) đảo lại theo bản cũ — đường dẫn mở, MENU vẫn ẩn (`menuRoles`).
    '/az/dashboard': false, '/az/sales': true, '/az/pricing': true, '/az/stats': true,
    '/az/billing': true, '/az/ops': true, '/az/purchase-docs': false, '/az/vendor-pnl': false,
    '/az/gia-duong-sat': false,
    '/az/hoa-hong': false,
    '/hoa-hong-cua-toi': true,
    '/az/chao-gia': false,
    '/az/ke-hoach': false,
    '/az/ops-catalog': false, '/az/container-ops': true,
    '/approvals': true, '/chi': false, '/catalog': true, '/quan-tri': false, '/finance': false, '/ar': false,
    '/ap': false, '/chung-tu': false, '/settings': false, '/': true, '/ncc/login': true,
  },
  // ncc: CHỈ 4 route công khai (kể cả '/ncc/login', khớp tiền tố '/ncc') — mọi đường dẫn công ty
  // khác đều chặn, KỂ CẢ trang chủ '/' (khác 7 vai kia — '/' không hạn chế nhưng ncc bị chặn TRƯỚC
  // khi tới bước đó, xem `canAccessRoute`).
  ncc: {
    '/login': true, '/tra-cuu': true, '/ncc': true,
    '/az/dashboard': false, '/az/sales': false, '/az/pricing': false, '/az/stats': false,
    '/az/billing': false, '/az/ops': false, '/az/purchase-docs': false, '/az/vendor-pnl': false,
    '/az/gia-duong-sat': false,
    '/az/hoa-hong': false,
    '/hoa-hong-cua-toi': false,
    '/az/chao-gia': false,
    '/az/ke-hoach': false,
    '/az/ops-catalog': false, '/az/container-ops': false,
    '/approvals': false, '/chi': false, '/catalog': false, '/quan-tri': false, '/finance': false, '/ar': false,
    '/ap': false, '/chung-tu': false, '/settings': false, '/': false, '/ncc/login': true,
  },
}
